"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StarsReviewItem = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Icon = require("../Icon");

var _Icons = require("../Icons");

var _Buttons = require("../Buttons");

var StarsReviewItem = function StarsReviewItem(_ref) {
  var index = _ref.index,
      selected = _ref.selected,
      _onClick = _ref.onClick,
      handleOnMouseOver = _ref.handleOnMouseOver,
      handleOnMouseLeave = _ref.handleOnMouseLeave,
      hasMargins = _ref.hasMargins;

  var _useState = (0, _react.useState)('guama'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      color = _useState2[0],
      setColor = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hovered = _useState4[0],
      setHovered = _useState4[1];

  (0, _react.useEffect)(function () {
    if (hovered && selected) {
      setColor('variants.rambutan.light');
      return;
    }

    if (selected || hovered) {
      setColor('rambutan');
      return;
    }

    setColor('guama');
  }, [hovered, selected]);

  var onMouseOver = function onMouseOver() {
    setHovered(true);
    handleOnMouseOver();
  };

  var onMouseLeave = function onMouseLeave() {
    setHovered(false);
    handleOnMouseLeave();
  };

  return _react.default.createElement(_Buttons.Button, {
    key: index,
    buttonType: "text",
    marginRight: hasMargins ? 2 : 0,
    size: "none",
    onClick: function onClick() {
      _onClick(index);
    },
    onMouseOver: onMouseOver,
    onMouseLeave: onMouseLeave
  }, _react.default.createElement(_Icon.IconForm, {
    marginRight: hasMargins ? 2 : 0,
    size: "medium",
    color: color,
    key: index
  }, _react.default.createElement(_Icons.StarSolid, {
    key: index
  })));
};

exports.StarsReviewItem = StarsReviewItem;
StarsReviewItem.defaultProps = {
  hasMargins: true
};